import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import useAuth from '@shared/utils/hooks/useAuth';
import { useQuery } from '@tanstack/react-query';
import { type EventData, EVENTS, Joyride, type Step } from 'react-joyride';
import useGuideStorage from '../../hooks/useGuideStorage';
import { client, service } from '../../utils/trpc';
import { CustomJoyrideTooltip } from '../common/CustomJoyrideTooltip';
type Props = {
  factiiiId: number;
  onComplete?: () => void;
};
const FactiiiGuide = t0 => {
  const $ = _c(22);
  const {
    factiiiId,
    onComplete
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      client,
      service
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    currentUser
  } = useAuth(t1);
  const {
    hasViewedGuide,
    addViewedGuide
  } = useGuideStorage();
  const t2 = `factiii-${factiiiId}`;
  let t3;
  if ($[1] !== t2) {
    t3 = ["guide", t2];
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== currentUser || $[4] !== factiiiId || $[5] !== hasViewedGuide) {
    t4 = () => {
      if (!currentUser.isAuthenticated) {
        if (hasViewedGuide(factiiiId)) {
          return null;
        }
      }
      return unwrapFromResult(client.guides.getGuideByFactiii.query({
        factiiiId
      }));
    };
    $[3] = currentUser;
    $[4] = factiiiId;
    $[5] = hasViewedGuide;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      queryKey: t3,
      queryFn: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const {
    data: guide
  } = useQuery(t5);
  let t6;
  if ($[10] !== addViewedGuide || $[11] !== factiiiId || $[12] !== guide || $[13] !== onComplete) {
    t6 = t7 => {
      const {
        status,
        type
      } = t7;
      const isTourActive = !["finished", "skipped", "ready"].includes(status);
      if (isTourActive) {
        document.body.classList.add("overflow-hidden");
      } else {
        document.body.classList.remove("overflow-hidden");
      }
      if (type === EVENTS.TOUR_END) {
        if (guide) {
          addViewedGuide(factiiiId);
        }
        onComplete?.();
      }
    };
    $[10] = addViewedGuide;
    $[11] = factiiiId;
    $[12] = guide;
    $[13] = onComplete;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handleJoyrideEvent = t6;
  if (!guide || guide.steps.length === 0) {
    return null;
  }
  let t7;
  if ($[15] !== guide.steps) {
    t7 = guide.steps.map(_temp);
    $[15] = guide.steps;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      last: "Finish"
    };
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      buttons: ["back", "primary"],
      overlayClickAction: false,
      dismissKeyAction: false,
      arrowColor: "rgba(var(--background-secondary-color), 1)"
    };
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== handleJoyrideEvent || $[20] !== t7) {
    t10 = <Joyride steps={t7} continuous={true} run={true} tooltipComponent={CustomJoyrideTooltip} locale={t8} onEvent={handleJoyrideEvent} options={t9} />;
    $[19] = handleJoyrideEvent;
    $[20] = t7;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
};
export default FactiiiGuide;
function _temp(step) {
  return {
    id: String(step.id),
    title: step.title,
    content: step.content,
    target: step.target,
    placement: step.placement as Step['placement'],
    skipBeacon: true,
    skipScroll: true
  };
}